import * as actionTypes from 'constants/ActionTypes';

export function connectNewDomainToUser(data) {
    return {
        type: actionTypes.CONNECT_NEW_DOMAIN_TO_USER.REQUEST,
        data,
    };
}

export function deleteDomain(data) {
    return {
        type: actionTypes.DELETE_DOMAIN.REQUEST,
        data,
    };
}

export function getListDomain() {
    return {
        type: actionTypes.GET_LIST_DOMAIN.REQUEST,
    };
}


// WEBPACK FOOTER //
// ./app/actions/domains.js